import { render, staticRenderFns } from "./OrderListItemSipControls.vue?vue&type=template&id=b408d940&scoped=true"
import script from "./OrderListItemSipControls.vue?vue&type=script&lang=js"
export * from "./OrderListItemSipControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b408d940",
  null
  
)

export default component.exports